import Head from './TopHead';
import Curric from './Curric';

function ChatGPT() {
    return (
        <main>
            <Head />

            <h1>Chat GPT - AI for Data Analysis</h1>
            <h3 className="main-subtitle"><b>Human Empowered AI use.</b> Learn how to keep your Data Private & Remain in Control while using all the binefits of AI.</h3>

            <section className="section">
                <h2>Chat GPT: Data Analytics</h2>

                <div className="sectional">
                    <small className="hide-print">Click to see material covered.</small>

                    <Curric title="Data Analysis with Chat GPT & Python Pandas (4 Hours)">
                        <ul>
                            <li>Setup Anaconda distribution of the Python</li>
                            <li>Using Jupyter Notebook</li>
                            <li>Connect to Data</li>
                            <li>Reading data from files (e.g., CSV, Excel, JSON)</li>
                            <li>Understand Pandas DataFrames</li>
                            <li>Understand Data Types</li>
                            <li>Using Chat GPT to Transform the Data</li>
                            <li>Using Chat GPT to Filter & Sort</li>
                            <li>Using Chat GPT to Merge and Join DataFrames</li>
                            <li>Using Chat GPT to Aggregating Data (aka Pivot, Group By)</li>
                            <li>Using Chat GPT to Plot Charts</li>
                            <li>Learn how to Export Data</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Basic understanding of data and tables. Previous experience with Excel is recommended.</div>
                    </Curric>

                    <Curric title="Data Analysis with Chat GPT & SQL/MySQL (4 Hours)">
                        <ul>
                            <li>Setup MySQL local Environment</li>
                            <li>Connect to Data</li>
                            <li>Tables & Fields</li>
                            <li>Run SQL Queries</li>
                            <li>Basic SQL Syntax</li>
                            <li>Understand Data Types</li>
                            <li>Using Chat GPT to Filter & Sort Data</li>
                            <li>Using Chat GPT to Filter Data with Partial Matches</li>
                            <li>Functions</li>
                            <li>Date Functions</li>
                            <li>Create Calculated Columns</li>
                            <li>SQL JOINS</li>
                            <li>Undestand JOIN Types</li>
                            <li>AGGREGATE functions</li>
                            <li>Using Chat GPT to Write AGGREGATE Queries</li>
                            <li>GROUP BY</li>
                            <li>Using Chat GPT to Write GROUP BY Queries</li>
                            <li>UNION, UNION ALL</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Basic understanding of data and tables. Previous experience with Excel is recommended.</div>
                    </Curric>

                    <Curric title="Excel Formulas with Chat GPT  (2 Hours)">
                        <ul>
                            <li>Basic Excel Formula References & Calculations</li>
                            <li>Excel Formula References from Other Sheets</li>
                            <li>Why it's Important to Understand Data Types?</li>
                            <li>How to Convert Between Data Types</li>
                            <li>Using Chat GPT</li>
                            <li>Know What to Prompt</li>
                            <li>Break Down Your Steps</li>
                            <li>Check Your Results</li>
                        </ul>
                        <div className="prerequisites"><b>Prerequisites:</b> Basic level experience with Excel.</div>
                    </Curric>

                </div>
            </section>

            <hr />

        </main>

    );
}

export default ChatGPT;